import {NgModule} from '@angular/core';
import {LoyaltyCardComponent} from './views/common/components/loyalty-card/loyalty-card.component';
import {SettingsButtonComponent} from './views/common/components/settings-button/settings-button.component';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {LoyaltyPointComponent} from './views/common/components/loyalty-point/loyalty-point.component';
import {CardCustomizerComponent} from './views/common/components/card-customizer/card-customizer.component';
import {SmallLoyaltyCardComponent} from './views/common/components/small-loyalty-card/small-loyalty-card.component';
import {SwiperModule} from 'swiper/angular';
import {HeaderComponent} from './views/common/components/header/header.component';
import {ButtonComponent} from './views/common/components/button/button.component';
import {RewardComponent} from './views/common/components/reward/reward.component';
import {LockClosedIconComponent} from './views/common/components/svg/lock-closed-icon/lock-closed-icon.component';
import {NfcIconComponent} from './views/common/components/svg/nfc-icon/nfc-icon.component';
import {PointComponent} from './views/customer/components/point/point.component';
import {GaugeComponent} from './views/customer/components/gauge/gauge.component';
import {BusinessMemberComponent} from './views/business/components/business-member/business-member.component';
import {OptionByUnitConsumptionItemComponent} from './views/business/components/options/option-by-unit-consumption-item/option-by-unit-consumption-item.component';
import {PromotionComponent} from './views/common/components/promotion/promotion.component';
import {AddressItemComponent} from './views/business/components/address-item/address-item.component';
import {MomentModule} from 'ngx-moment';
import {NotificationItemComponent} from './views/common/components/notification-item/notification-item.component';
import {NotificationHasBeenSeenDirective} from './views/common/directives/notification-has-been-seen.directive';
import {NotificationIconComponent} from './views/common/components/svg/notification-icon/notification-icon.component';
import {AnimateNumberPipe} from './views/common/pipes/animate-number.pipe';
import {CompleteFloatByZeroPipe} from './views/common/pipes/complete-float-by-zero.pipe';
import {ActivateNotificationsModalComponent} from './views/common/components/modals/activate-notifications-modal/activate-notifications-modal.component';
import {HandshakeIconComponent} from './views/common/components/svg/handshake-icon/handshake-icon.component';
import {OptionsHowItWorksModalComponent} from "./views/business/components/modals/options-how-it-works-modal/options-how-it-works-modal.component";
import {FlashIconComponent} from './views/common/components/svg/flash-icon/flash-icon.component';
import {OptionsIconComponent} from './views/common/components/svg/options-icon/options-icon.component';
import {PricingModalComponent} from './views/common/components/modals/pricing-modal/pricing-modal.component';
import {SponsorshipForCustomerModalComponent} from './views/common/components/modals/sponsorship-for-customer-modal/sponsorship-for-customer-modal.component';
import {GalleryIconComponent} from './views/common/components/svg/gallery-icon/gallery-icon.component';
import {StatisticIconComponent} from './views/common/components/svg/statistic-icon/statistic-icon.component';
import {ProfileIconComponent} from './views/common/components/svg/profile-icon/profile-icon.component';
import {WalletIconComponent} from './views/common/components/svg/wallet-icon/wallet-icon.component';

@NgModule({
  declarations: [
    LoyaltyCardComponent,
    SettingsButtonComponent,
    LoyaltyPointComponent,
    CardCustomizerComponent,
    SmallLoyaltyCardComponent,
    HeaderComponent,
    RewardComponent,
    LockClosedIconComponent,
    NotificationIconComponent,
    NfcIconComponent,
    FlashIconComponent,
    OptionsIconComponent,
    PointComponent,
    ButtonComponent,
    GaugeComponent,
    BusinessMemberComponent,
    OptionByUnitConsumptionItemComponent,
    PromotionComponent,
    AddressItemComponent,
    NotificationItemComponent,
    NotificationHasBeenSeenDirective,
    AnimateNumberPipe,
    CompleteFloatByZeroPipe,
    ActivateNotificationsModalComponent,
    HandshakeIconComponent,
    OptionsHowItWorksModalComponent,
    PricingModalComponent,
    SponsorshipForCustomerModalComponent,
    GalleryIconComponent,
    StatisticIconComponent,
    ProfileIconComponent,
    WalletIconComponent,
  ],
  exports: [
    LoyaltyCardComponent,
    SettingsButtonComponent,
    LoyaltyPointComponent,
    CardCustomizerComponent,
    SmallLoyaltyCardComponent,
    HeaderComponent,
    RewardComponent,
    LockClosedIconComponent,
    NotificationIconComponent,
    NfcIconComponent,
    FlashIconComponent,
    OptionsIconComponent,
    PointComponent,
    ButtonComponent,
    GaugeComponent,
    BusinessMemberComponent,
    OptionByUnitConsumptionItemComponent,
    PromotionComponent,
    AddressItemComponent,
    NotificationItemComponent,
    NotificationHasBeenSeenDirective,
    AnimateNumberPipe,
    CompleteFloatByZeroPipe,
    ActivateNotificationsModalComponent,
    HandshakeIconComponent,
    OptionsHowItWorksModalComponent,
    PricingModalComponent,
    SponsorshipForCustomerModalComponent,
    GalleryIconComponent,
    StatisticIconComponent,
    ProfileIconComponent,
    WalletIconComponent,
  ],
    imports: [
        IonicModule,
        CommonModule,
        RouterModule,
        SwiperModule,
        MomentModule
    ]
})
export class SharedModule {}
